import React, { useEffect } from 'react';
import { NavHeader } from '../PageElements/NavHeader';
import Header from '../PageElements/Header';
import Footer from '../PageElements/Footer';
import ScrollReset from '../Tools/ScrollReseter';
import validator from 'validator';
import HCaptcha from '@hcaptcha/react-hcaptcha';
import { useLocation } from 'react-router';

const accessKeys = new Map();
accessKeys.set('General', '8c5f60cb-27e4-4e70-a0c7-0fcc1e864039');
accessKeys.set('Investment&Funding', '1e74fb22-b253-4acc-b97e-c8738909a1a2');
accessKeys.set('Media&Press', '46247653-1d26-4a73-88a6-13e362c5fbc3');
accessKeys.set('CareerOpportunities', 'e0a79d10-f228-4565-8380-820582a9a3f6');

export default function ContactUs() {
  const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <>
      <ScrollReset />
      <div className='wrapper'>
        <NavHeader maxScroll={200} windowWidth={windowWidth} />
        <Header imageURL={'Images/Difference.png'} title={'Contact Us'} titleSize={windowWidth > 750 ? 48 : 28} windowWidth={windowWidth} />
        <Content windowWidth={windowWidth}/>
        <Footer imageURL={'Images/Difference.png'} windowWidth={windowWidth} />
      </div>
    </>
  );
}

function ContactForm({windowWidth}) {
  const location = useLocation();
  const [result, setResult] = React.useState('Send Message');
  const topic = location?.state?.topic;

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    const form = document.getElementById('ContactForm');
    const hCaptcha = form.querySelector('textarea[name=h-captcha-response]').value;

    //Check for a valid email
    if (!validator.isEmail(formData.get('email'))) {
      alert('Please use a valid email');
      return;
    }

    //Check for a valid captcha
    if (!hCaptcha) {
      alert('Please fill out captcha field');
      return;
    }

    //Check for the topic key
    const keyForTopic = accessKeys.get(formData.get('topic'));
    if (keyForTopic) formData.append('access_key', keyForTopic); //'c0e198d7-e954-4a85-bbc0-d77e350dbd1b'
    else {
      console.error('Issue grabbing the key for the specific topic');
      return;
    }

    setResult('Sending....');
    const response = await fetch('https://api.web3forms.com/submit', {
      method: 'POST',
      body: formData,
    });

    const data = await response.json();
    if (data.success) {
      setResult('Form Submitted!');

      //Reset logic
      setTimeout(() => {
        setResult('Send Message');

        //Reset the captcha
        if (window.hcaptcha) {
          window.hcaptcha.reset();
        }
      }, 2500);

      event.target.reset();
    } else {
      console.log('Error', data);
      setResult(data.message);
    }
  };

  return (
    <form onSubmit={onSubmit} id='ContactForm'>
      <h1 style={{ fontSize: '32px' }}>Get In Touch</h1>

      <div id='Content'>
        {windowWidth > 940 && (
          <>
            <svg
              style={{ position: 'absolute', left: '-60px', pointerEvents: 'none' }}
              width='190'
              height='calc(100% + 80px)'
              viewBox='0 0 190 779'
              fill='none'
              preserveAspectRatio='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M190 778H21C9.95431 778 0.999999 769.046 0.999999 758V21C0.999999 9.95431 9.9543 1 21 1H190'
                stroke='url(#paint0_linear_223_497)'
                strokeWidth='2'
              />
              <defs>
                <linearGradient id='paint0_linear_223_497' x1='1.00001' y1='389.14' x2='190.501' y2='389.14' gradientUnits='userSpaceOnUse'>
                  <stop stopColor='#5472B8' />
                  <stop offset='1' stopColor='#5472B8' stopOpacity='0' />
                </linearGradient>
              </defs>
            </svg>

            <svg
              style={{ position: 'absolute', right: '-60px', pointerEvents: 'none' }}
              width='190'
              height='calc(100% + 80px)'
              viewBox='0 0 190 779'
              preserveAspectRatio='none'
              fill='none'
              xmlns='http://www.w3.org/2000/svg'>
              <path
                d='M0 778H169C180.046 778 189 769.046 189 758V21C189 9.95431 180.046 1 169 1H0'
                stroke='url(#paint0_linear_223_499)'
                strokeWidth='2'
              />
              <defs>
                <linearGradient id='paint0_linear_223_499' x1='189' y1='389.14' x2='-0.501326' y2='389.14' gradientUnits='userSpaceOnUse'>
                  <stop stopColor='#5472B8' />
                  <stop offset='1' stopColor='#5472B8' stopOpacity='0' />
                </linearGradient>
              </defs>
            </svg>
          </>
        )}

        <div className='field '>
          <label htmlFor='topic'>Topic</label>
          <div className='select-wrapper'>
            <select name='topic' required className='input' style={{ border: 'none' }}>
              <option value='' disabled selected>
                Please Select a Topic
              </option>
              <option value='General'>General</option>
              <option value='Investment&Funding'>Investment & Funding</option>
              <option value='Media&Press'>Media & Press</option>
              <option value='CareerOpportunities' selected={topic === 'CareerOpportunities'}>
                Career Opportunities
              </option>
            </select>
          </div>
        </div>

        <div id='DoubleField'>
          <div className='field'>
            <label htmlFor='firstName'>First Name</label>
            <input type='text' name='firstName' placeholder='First Name' required className='input'></input>
          </div>

          <div className='field'>
            <label htmlFor='lastName'>Last Name</label>
            <input type='text' name='lastName' placeholder='Last Name' required className='input'></input>
          </div>
        </div>

        <div className='field'>
          <label htmlFor='email'>Email</label>
          <input type='email' name='email' placeholder='What is your email?' required className='input'></input>
        </div>

        <div className='field'>
          <label htmlFor='subject'>Subject</label>
          <input type='text' minLength={'10'} name='subject' placeholder='What is your subject?' required className='input'></input>
        </div>

        <div className='field'>
          <label htmlFor='message'>Message</label>
          <textarea type='text' name='message' placeholder='Leave us a message' required className='input' id='Message'></textarea>
        </div>

        <HCaptcha sitekey='50b2fe65-b00b-4b9e-ad62-3ba471098be2' reCaptchaCompat={false} />
        <input className='submit' type='submit' value={result}></input>
      </div>
    </form>
  );
}

function Content({windowWidth}) {
  return (
    <>
      <div className='content' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <ContactForm windowWidth={windowWidth}/>
      </div>
    </>
  );
}
